// extracted by mini-css-extract-plugin
export var askAiIcon = "_oa-k";
export var category = "_oa-a";
export var categoryHeader = "_oa-f";
export var container = "_oa-0";
export var group = "_oa-b";
export var groupItems = "_oa-g";
export var groupSeparator = "_oa-l";
export var highlight = "_oa-8";
export var loading = "_oa-1";
export var noResults = "_oa-3";
export var placeholder = "_oa-2";
export var resultContent = "_oa-5";
export var resultIcon = "_oa-d";
export var resultItem = "_oa-h";
export var resultMeta = "_oa-9";
export var resultSubtitle = "_oa-7";
export var resultSuffix = "_oa-j";
export var resultTitle = "_oa-6";
export var resultsList = "_oa-4";
export var searchGroup = "_oa-e";
export var selected = "_oa-i";
export var subgroup = "_oa-c";